import { CircularProgress } from '@mui/material';
import styled from 'styled-components';

const StyledCircularProgress = styled(CircularProgress)`
    background: #f9fafa;
`;

const Loader = () => <StyledCircularProgress color="primary" />;

export default Loader;
